import Table from "@tiptap/extension-table";

export const CustomTable = Table.extend({
  addAttributes() {
    return {
      class: {
        default: null,
        renderHTML: (attributes) => {
          return {
            class: `${attributes.class}`,
          };
        },
      },
    };
  },
});
